
import Booking from "@/interfaces/Contracts/Booking";
import { Vue, Component, Prop } from "vue-property-decorator";
import CardListDetailField from "@/components/Base/CardListDetail/CardListDetailField.vue";
import {
  formatCurrency,
  formatNumber,
} from "@/helpers/Numeric/NumericFormattingHelpers";

@Component({ components: { CardListDetailField } })
export default class DetailBookingHeader extends Vue {
  @Prop({ required: true })
  booking!: Booking;

  @Prop({ required: false, default: false })
  loading!: boolean;

  private priceText(useCurrent: boolean, price: number) {
    if (useCurrent) return "Current";

    return formatCurrency(price);
  }

  private quantityText(isQuote: boolean, quantity: number): string {
    return isQuote ? "Quote" : formatNumber(quantity, 4);
  }
}
